/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
  font-family: $font-family-base;
}

::slotted(*) {
  display: none;
}

nav.#{$prefix}breadcrumb ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

nav.#{$prefix}breadcrumb li {
  display: inline-flex;
  align-items: center;

  &:first-child,
  &:first-child a {
    margin-left: 0;
  }

  @include for-size(phone) {
    display: none;
    &:last-child,
    &:nth-last-child(2) {
      display: inline-flex;
    }
  }

  span.#{$prefix}separator {
    display: inline-block;
    fill: v(contentColor);
    width: 10px;
    height: 24px;
    margin: 0 7px;
  }

  eon-ui-icon {
    color: v(iconColor);
  }

  a {
    &:hover {
      text-decoration: underline;
      color: v(contentHoverColor);
    }

    &:focus {
      @include focusBorder(v(contentColor));
    }

    font-size: $copy-small-font-size;
    font-weight: $copy-small-font-weight;
    line-height: $copy-small-line-height;
    color: v(contentColor);
    text-decoration: none;

    &[aria-current="page"] {
      font-weight: $font-weight-bold;
      text-decoration: none;
      pointer-events: none;
    }
  }
}

nav.#{$prefix}breadcrumb {
  &.#{$prefix}large {
    a {
      font-size: $copy-font-size;
      line-height: $copy-line-height;
    }
  }
}
